<div>

  <div class="mt-3">
    <p-table [value]="processos" [lazy]="true" dataKey="id" (onLazyLoad)="carregar($event)" [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[10, 20, 50]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400'}" #dt>
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <span class="font-semibold">{{ titulo }}</span>
          <button pButton type="button" icon="pi pi-refresh" label="Atualizar" class="p-button-text p-button-sm" (click)="atualizar()"></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="servico">Serviço <p-sortIcon field="servico"></p-sortIcon></th>
          <th pSortableColumn="processo">Processo <p-sortIcon field="processo"></p-sortIcon></th>
          <th pSortableColumn="instancia">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
          <th pSortableColumn="usuario">Usuário <p-sortIcon field="usuario"></p-sortIcon></th>
          <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
          <th pSortableColumn="dtSolicitacao">Dt Solicitação <p-sortIcon field="dtSolicitacao"></p-sortIcon></th>
          <th pSortableColumn="dtInicio">Início <p-sortIcon field="dtInicio"></p-sortIcon></th>
          <th pSortableColumn="dtFim">Fim <p-sortIcon field="dtFim"></p-sortIcon></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-p>
        <tr>
          <td>{{ p.servico }}</td>
          <td>{{ p.processo }}</td>
          <td>{{ p.instancia }}</td>
          <td>{{ p.usuario }}</td>
          <td>
            <p-tag [value]="p.status" [severity]="severity(p.status)" [pTooltip]="p.mensagemErro" tooltipPosition="top"></p-tag>
          </td>
          <td>{{ p.dtSolicitacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ p.dtInicio | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ p.dtFim | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>
            <button pButton type="button" icon="pi pi-search" class="p-button-rounded p-button-text" pTooltip="Detalhes" tooltipPosition="top" (click)="verDetalhe(p)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9">Nenhum processo encontrado</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog header="Detalhe do Processo" [(visible)]="exibirDetalhe" [modal]="true" [style]="{width: '40rem'}" [draggable]="false" [resizable]="false">
    <div *ngIf="processoSelecionado">
      <div class="grid">
        <div class="col-6"><strong>Serviço:</strong> {{ processoSelecionado.servico }}</div>
        <div class="col-6"><strong>Processo:</strong> {{ processoSelecionado.processo }}</div>
        <div class="col-6"><strong>Instância:</strong> {{ processoSelecionado.instancia }}</div>
        <!-- <div class="col-6"><strong>Chave Concorrência:</strong> {{ processoSelecionado.chaveConcorrencia }}</div> -->
        <!-- <div class="col-6"><strong>Nó Execução:</strong> {{ processoSelecionado.noExecucao }}</div> -->
        <div class="col-6"><strong>Usuário:</strong> {{ processoSelecionado.usuario }}</div>
        <div class="col-6"><strong>Status:</strong> <p-tag [value]="processoSelecionado.status" [severity]="severity(processoSelecionado.status)"></p-tag></div>
        <div class="col-6"><strong>Dt Solicitação:</strong> {{ processoSelecionado.dtSolicitacao | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        <div class="col-6"><strong>Início:</strong> {{ processoSelecionado.dtInicio | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        <div class="col-6"><strong>Fim:</strong> {{ processoSelecionado.dtFim | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        <div class="col-6"><strong>Heartbeat:</strong> {{ processoSelecionado.dtHeartbeat | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
      </div>

      <div *ngIf="processoSelecionado.mensagemErro" class="mt-2">
        <strong>Mensagem de Erro:</strong>
        <div class="p-error">{{ processoSelecionado.mensagemErro }}</div>
      </div>

      <div *ngIf="processoSelecionado.parametros" class="mt-2">
        <strong>Parâmetros:</strong>
        <pre class="parametros">{{ formatarParametros() }}</pre>
      </div>

      <div *ngIf="processoSelecionado.eventos?.length" class="mt-3">
        <strong>Eventos:</strong>
        <p-timeline [value]="processoSelecionado.eventos" class="mt-2">
          <ng-template pTemplate="opposite" let-evento>
            <small class="text-color-secondary">{{ evento.dtEvento | date: 'dd/MM/yyyy HH:mm:ss' }}</small>
          </ng-template>
          <ng-template pTemplate="content" let-evento>
            <div class="font-semibold">{{ evento.etapa }}</div>
            <div *ngIf="evento.mensagem">{{ evento.mensagem }}</div>
            <pre *ngIf="evento.detalhes" class="parametros mt-1">{{ formatarDetalhesEvento(evento) }}</pre>
          </ng-template>
        </p-timeline>
      </div>
    </div>
  </p-dialog>

</div>
